var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDibpos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 22,
    viewBox: "0 0 30 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_4294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4071 16.2552C14.1054 16.2552 15.4821 14.8874 15.4821 13.2C15.4821 11.5127 14.1054 10.1448 12.4071 10.1448C10.7088 10.1448 9.33209 11.5127 9.33209 13.2C9.33209 14.8874 10.7088 16.2552 12.4071 16.2552Z",
    fill: "url(#paint0_linear_3_4294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.84638 17.3185C8.04104 17.3185 9.00948 16.3563 9.00948 15.1693C9.00948 13.9824 8.04104 13.0202 6.84638 13.0202C5.65174 13.0202 4.68329 13.9824 4.68329 15.1693C4.68329 16.3563 5.65174 17.3185 6.84638 17.3185Z",
    fill: "url(#paint1_linear_3_4294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.84634 12.0693C7.73789 12.0693 8.46063 11.3512 8.46063 10.4654C8.46063 9.57959 7.73789 8.86151 6.84634 8.86151C5.95479 8.86151 5.23206 9.57959 5.23206 10.4654C5.23206 11.3512 5.95479 12.0693 6.84634 12.0693Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.44643 13.6719C4.10851 13.6719 4.64524 13.1387 4.64524 12.4809C4.64524 11.8231 4.10851 11.2898 3.44643 11.2898C2.78435 11.2898 2.24762 11.8231 2.24762 12.4809C2.24762 13.1387 2.78435 13.6719 3.44643 13.6719Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.99053 10.4654C3.56977 10.4654 4.03934 9.99883 4.03934 9.42333C4.03934 8.84783 3.56977 8.38129 2.99053 8.38129C2.41128 8.38129 1.94171 8.84783 1.94171 9.42333C1.94171 9.99883 2.41128 10.4654 2.99053 10.4654Z",
    fill: "url(#paint2_linear_3_4294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.747618 12.0314C1.16052 12.0314 1.49524 11.6988 1.49524 11.2886C1.49524 10.8784 1.16052 10.5458 0.747618 10.5458C0.334719 10.5458 0 10.8784 0 11.2886C0 11.6988 0.334719 12.0314 0.747618 12.0314Z",
    fill: "url(#paint3_linear_3_4294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9142 5.62538C15.0344 5.46215 13.0023 5.66559 9.92375 5.62538C7.25114 5.62538 4.6428 4.03688 3.97137 0H18.9142C21.5006 4.32544e-05 24.0051 0.900809 25.9923 2.54564C27.9794 4.19047 29.3235 6.47529 29.7905 9.00274C30.2576 11.5302 29.8183 14.1403 28.5489 16.3792C27.2795 18.6183 25.2605 20.3442 22.8428 21.2572C22.1031 21.535 21.3357 21.7333 20.5535 21.8486L20.5189 21.8332L20.5023 21.8249C19.2654 21.2229 18.338 19.1802 18.338 17.7337C18.3372 17.2532 18.4331 16.7775 18.6201 16.3344C18.7178 16.3344 18.8166 16.3427 18.9154 16.3427C19.5892 16.3416 20.256 16.208 20.8774 15.9493C21.4987 15.6906 22.0624 15.3122 22.5356 14.8358C22.7154 14.657 22.882 14.4656 23.0344 14.2633C23.7451 13.3159 24.1274 12.1651 24.1237 10.9834C24.1237 8.02645 21.7928 5.62301 18.9154 5.62301",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5511 21.8498L20.432 21.7776L20.0749 21.5541C19.0582 20.7474 18.338 19.0111 18.338 17.736C18.3371 17.2556 18.4331 16.7799 18.6201 16.3368C18.8981 15.5279 19.049 14.6813 19.0677 13.8269C19.0686 13.22 18.9488 12.619 18.7153 12.0581C18.4819 11.4973 18.1394 10.9878 17.7075 10.5587C17.2755 10.1297 16.7626 9.78951 16.1981 9.55773C15.6336 9.32596 15.0286 9.20714 14.4177 9.20807C14.2761 9.20807 14.1332 9.21399 13.9951 9.227C13.5353 9.26814 13.0843 9.37738 12.657 9.55109C12.7142 9.55109 12.7725 9.55109 12.832 9.55109C13.812 9.55109 14.752 9.93789 15.445 10.6264C16.138 11.3149 16.5272 12.2488 16.5272 13.2225C16.5272 14.1962 16.138 15.13 15.445 15.8186C14.752 16.5071 13.812 16.8939 12.832 16.8939C12.7368 16.8939 12.6427 16.8939 12.5487 16.8832V16.8939C12.4296 20.7498 15.8415 22.2945 20.5534 21.8545L20.5511 21.8498Z",
    fill: "#F5F5F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_4294",
    x1: 9.33209,
    y1: 13.2,
    x2: 15.4821,
    y2: 13.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3_4294",
    x1: 4.68329,
    y1: 15.1693,
    x2: 9.00948,
    y2: 15.1693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3_4294",
    x1: 1.94171,
    y1: 9.42333,
    x2: 4.03934,
    y2: 9.42333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3_4294",
    x1: 0,
    y1: 11.2886,
    x2: 1.49524,
    y2: 11.2886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_4294"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDibpos);
export default __webpack_public_path__ + "static/media/dibpos.62228b9a92708a85de97bc1c0efcab20.svg";
export { ForwardRef as ReactComponent };